import { useCallback, useContext, useEffect } from 'react'
import { useState } from 'react'
import { TenantsContext } from '../../../../context/tenants.context'
import { getAtributosRubro, getGruposAtr, getMonedas, getUnidadesDeMedida } from './data.rubros.service'
import { GruposAtributos } from '../../../Integraciones/types/responses'

export const useDataABMRubros = (isAdmin: boolean) => {
  const [unidadesDeMedidaDisponibles, setUnidadesDeMedidaDisponibles] = useState<any[]>([])
  const [atributos, setAtributos] = useState<any[]>([])
  const [monedas, setMonedas] = useState<any[]>([])
  const [gruposAtr, setGruposAtr] = useState<GruposAtributos[]>([])
  const { tenant } = useContext(TenantsContext)

  const fetchAtr = useCallback(async () => {
    try {
      const res = await getAtributosRubro(tenant)
      setAtributos(res.data.data)
    } catch (e) {
      console.error('Error: ', e)
    }
  }, [tenant])

  const fetchGrupos = useCallback(async () => {
    try {
      const res = await getGruposAtr(tenant)
      setGruposAtr(res.data.data)
    } catch (e) {
      console.error('Error: ', e)
    }
  }, [tenant])

  const fetchUnidades = useCallback(async () => {
    try {
      const res = await getUnidadesDeMedida(tenant)
      setUnidadesDeMedidaDisponibles(res.data.data)
    } catch (e) {
      console.error('Error: ', e)
    }
  }, [tenant])

  const fetchMonedas = useCallback(async () => {
    try {
      const res = await getMonedas(tenant)
      setMonedas(res.data.data)
    } catch (e) {
      console.error('Error: ', e)
    }
  }, [tenant])

  useEffect(() => {
    if (isAdmin) {
      fetchUnidades()
      fetchMonedas()
    }
    fetchGrupos()
  }, [])

  return {
    unidadesDeMedidaDisponibles,
    atributos,
    monedas,
    gruposAtr
  }
}
